import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/fargate/692847e5/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ImageComponent = makeShortcode("ImageComponent");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "transferring-a-resource-from-a-local-system-to-a-remote-system"
    }}>{`Transferring a resource from a local system to a remote system.`}</h3>
    <ImageComponent cols="8" mdxType="ImageComponent">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "47.418397626112764%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAYAAAAywQxIAAAACXBIWXMAAAsSAAALEgHS3X78AAAB1klEQVQoz1VQS28SURjl11hc8+qSH8FD49KdiXZDExLDBqEdnvPgMdAwBVpDIZqmqa11o4Bhw6p0Y0yMiS2PhTaptjNNqjWn9/sKTZnk5Jt7z7kn53y28egE+wfvBD5g//0B9gRofvzURqf7Ge1Odw6dbpe5vamW9eLtzu4ufhwfw7ax+RoLdju8Xi9cbjccDieD/j2exVsszsPl9sDhdE7hEhoPHiw8xJu327BVjCoePX4CVctjVUoinZGRTqeRyWSQSqUgSRLPGYiTZRmKIvOkM93H43EcHg5gK5V0BAIB1Gp15PMFFIs6dF0Xsyjuamg2m4wtgVarhUajwfwMhUKBZzabxWDAhiUEg0FUKhUkEglORiQl6/V6sCwL5+e/YV78gWmaGA5HzN9vMUvKhuTu9/thGAYLbusoSCaT6Pf7+Ht1heHkF76f/IRpXWI4GkNVVTYlLYHO9PbO0OfzoV6vI5fLidp5rssVjo5A39fxP/S+WMB/C2enE+ZJR3Xn9PcNq9UqNE272w2tIhqNYmnpBUKhEJ7r3/B0/RrP1iZQtBw0kUpVNU5HQajRXGUyJIKMyuUyIxaLIRwOIxKJ4KVkYHllA8uv1sRKhJlYizIFBaH9k+ENh9TwqX+j9NkAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Contextual image",
          "title": "Contextual image",
          "src": "/static/ca9acd3805485df23cd1b57383237f4a/fb070/1.png",
          "srcSet": ["/static/ca9acd3805485df23cd1b57383237f4a/d6747/1.png 288w", "/static/ca9acd3805485df23cd1b57383237f4a/09548/1.png 576w", "/static/ca9acd3805485df23cd1b57383237f4a/fb070/1.png 1152w", "/static/ca9acd3805485df23cd1b57383237f4a/fb104/1.png 1728w", "/static/ca9acd3805485df23cd1b57383237f4a/902fb/1.png 2304w", "/static/ca9acd3805485df23cd1b57383237f4a/97c5b/1.png 8425w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </ImageComponent>
    <h2 {...{
      "id": "things-to-consider"
    }}>{`Things to consider`}</h2>
    <ul>
      <li parentName="ul">{`Is the action uploading or is it importing?`}</li>
      <li parentName="ul">{`Where is the upload action performed?`}</li>
      <li parentName="ul">{`How many items will the user need to upload at any one time? The UI shell is designed to be configurable. A product or platform can choose which shell components and configurations to use, based on their user and information requirements.`}</li>
    </ul>
    <h4 {...{
      "id": "options"
    }}>{`Options`}</h4>
    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Overview</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Upload methods</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Bulk upload</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`The action of uploading should always be the result of a user action.
The action of uploading a file could be done by selecting an action button
to open a modal or it may be done inline in a full page form or slide in or
over panel.`}</p>
    <style>
  {`
 .uploading-img-1 {
   max-width: 175px;
 }
`}
    </style>
    <ImageComponent className="uploading-img-1" mdxType="ImageComponent">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "26.96629213483146%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAFCAYAAABFA8wzAAAACXBIWXMAAAsSAAALEgHS3X78AAAAp0lEQVQY02NgSPr/nyERipMgmBFKQ8T+gWnG5H9A8X9IYv/g6lEw3CAQHQfE8UAcA8QJyIYCcTREDmHof9wGcqT//2/c+P+/ddv//+bN//+bNkFoZqCrQAZzJb37n9W9/79qwUuwpYyEXMic/P+/Ytn//5rVEFq96v9/2RKEd5kSvv9vmbHzv2nJjf8MsUA+XgORvQvDsVAaKQwZYv5CggOs/h9OLwMAv3rw/tiUGG4AAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Image of upload button",
          "title": "Image of upload button",
          "src": "/static/986305ab8c0676650b03368a80074e02/017fd/2.png",
          "srcSet": ["/static/986305ab8c0676650b03368a80074e02/d6747/2.png 288w", "/static/986305ab8c0676650b03368a80074e02/09548/2.png 576w", "/static/986305ab8c0676650b03368a80074e02/017fd/2.png 890w"],
          "sizes": "(max-width: 890px) 100vw, 890px",
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </ImageComponent>
    <br />
    <br />
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "76.12293144208037%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAYAAADkmO9VAAAACXBIWXMAAAsSAAALEgHS3X78AAAB4ElEQVQ4y5WT0WoTQRSG14Io4q4Qg6YhYAgF7/TCt1FRsd7pvXgjPkX1XTQ1JIKX2tqkhSBpogkRZXdndnY3mezs75xpUnZDG9KLj/9wztmfc2ZmLcYYRqMRxuMxXNdFEATgnF8I/Y0KwxCe5/UsSnQ6HbTbbWNKhXnT2ggh8oY6cWrk+z5oatLz4jNyKo5j+r5nZQsXXTWDiqKIPE4MV61INb2KYUWfmdAYLibLXsYiJqWjoB6C4mwteymnhtkJl5Vq/V9D9Ae/MdBKUO6M3nUMBZjvYnR8iH53H0Ot48EROHNXGy6vfKIBopBj8Edgp67woT7Fzqcp3u8qdIcCsa4xHqw3IcFYgFnM8e2nwNbrBA/eKdx/m+DumwSNgxBqqp8XO+cM6e9YflsLOPMxCX3EwjdTxZE2obNlefS0SoQxXE8bJkmCVcyI2QxqwjVM4881FyuoiLRntVqttNFopM1mM6U4qyYm/fI1rX/30o97Iq3vBenuD637gWEeq9aRxOeDsGcVi0VUq1UUCgXYtg3HcYwanBtwrl/FteIWrIf/YL8CrGeaR5rHOVLrickfW5VKRdZqNVkul2WpVMqzWZabt2/KW3fuyStP/0r7JeTlF0peep7Kje0ck41tQGv3P7GcGdWNovShAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Contextual image",
            "title": "Contextual image",
            "src": "/static/42f544b417f6e0358dcd858e27e84101/fb070/3.png",
            "srcSet": ["/static/42f544b417f6e0358dcd858e27e84101/d6747/3.png 288w", "/static/42f544b417f6e0358dcd858e27e84101/09548/3.png 576w", "/static/42f544b417f6e0358dcd858e27e84101/fb070/3.png 1152w", "/static/42f544b417f6e0358dcd858e27e84101/fb104/3.png 1728w", "/static/42f544b417f6e0358dcd858e27e84101/ff158/3.png 2115w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <br />
    <br />
    <h2 {...{
      "id": "upload-methods"
    }}>{`Upload methods`}</h2>
    <ul>
      <li parentName="ul">{`Drag and Drop`}</li>
      <li parentName="ul">{`Choose a file`}</li>
    </ul>
    <p>{`Wherever possible there should always be a drag and drop zone, using the file
drop component, as well as the ability to browse locally and select a file.
Note that file selection should be restricted to only allowed file types.`}</p>
    <br />
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "65.0485436893204%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACbUlEQVQ4y42STWgTQRTHp/UL60GlbdLQD0Vsb/EgiB8IHnvxLIIerFJbwRalgh6K9iCIgnrsQfSi1oOIIiJexIMnFS22pNa0tbsmMU3S3c3u7G66Sfb9ncn2I2CEDvx4OzPv/Xgzs0zXdaiqilQyCcuywDkXWOuAk8zVNM32PG8vE0PM65gUKoqKRDIF07RgWny9ELcd5E3Tdhx7TaiZLnIcWBRkzHIN/JrrWbNMlbq8axcdvUqYd4SQoNkS/MOi3OM190h3pbAghFptoSxeISgiZAxPzP1V+do+keYAOdEhN7VOKXz5Ra8XwuDI1QXyO5MvQ824UBZsKCIuiPlqx5XTkG+IDk1ekKu72Mr4n1AcBemkeP2EguxCArq460XZ9XKOLo6cNoF4ynHGPvND7A52dt9P76gSBok5C+BLhI9xYGAMuPSM0PcYePMdcD1C1gooFEGvvjk4citTOjz8Uzne985ouZy6x3KGLRL8yj1JsuJV7YKP91M+zj70MfCUcPoB4cVXgluUf4JACF0vEB69nSkfuBafunDiUSw0qL5mllOCsSTuQpBfjkZBdFNG1SB4JYLhEEw3iKUy6O2Ei+67aT96Ix0LDefHW4eSH1h8Zhax6TlMx+cxPTOPH8txKq6I9V+YnM1ifH4JE4qL2O+ASdXFXLpAzz9xnBzNFfeP/Hmy54o62jiYuM66ujqxLxpFe3sb2ttagyjp2I2O8DY0HruJyFWg8WIJm3oJW84HbO4lf2s/0NBPNjuFjtVXDofDaIlE0NTcjKamKkIRhLZvRMPBEdSJQtZTAjuDaoj1VKJdf44q/2HrkLXhL95YQqQVFoaXAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Contextual image",
            "title": "Contextual image",
            "src": "/static/cd9ca6227b16984362e38663a4669e61/fb070/4.png",
            "srcSet": ["/static/cd9ca6227b16984362e38663a4669e61/d6747/4.png 288w", "/static/cd9ca6227b16984362e38663a4669e61/09548/4.png 576w", "/static/cd9ca6227b16984362e38663a4669e61/fb070/4.png 1152w", "/static/cd9ca6227b16984362e38663a4669e61/fb104/4.png 1728w", "/static/cd9ca6227b16984362e38663a4669e61/902fb/4.png 2304w", "/static/cd9ca6227b16984362e38663a4669e61/5dfc8/4.png 3090w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <br />
    <br />
    <h2 {...{
      "id": "bulk-upload"
    }}>{`Bulk upload`}</h2>
    <ul>
      <li parentName="ul">{`Drag and Drop`}</li>
      <li parentName="ul">{`Choose files`}</li>
      <li parentName="ul">{`File information input fields`}</li>
    </ul>
    <p>{`As with the individual file upload there should always be a drag and drop
zone, using the file drop component, as well as the ability to browse locally
and select a files.`}</p>
    <br />
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1056px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "31.534090909090907%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAYAAADDl76dAAAACXBIWXMAAAsSAAALEgHS3X78AAAAp0lEQVQY06WPPQ7CMAxGe00mroUEEvdAXIONBQmoUIcmdpy/tvqomwWJhoXhOZb96clphmFACAExxuX9B3U1KjLGwFpbgdCbgva1nDrU1aSUQERg5lUcE1z/nGkhjkCVnDrUVRUS8SxgtB3hcOpwPHe4vwheym5NuFyoRU/WwSf6vSCE64Ox2Y3Y7kdcbg7Rl9133hZhzhkiUsV7wZQdxuQQvPzMqusNWEDLVLaOVmUAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Contextual image",
            "title": "Contextual image",
            "src": "/static/a902a2ed5a8e9a91592f14057a19e684/c488a/5.png",
            "srcSet": ["/static/a902a2ed5a8e9a91592f14057a19e684/d6747/5.png 288w", "/static/a902a2ed5a8e9a91592f14057a19e684/09548/5.png 576w", "/static/a902a2ed5a8e9a91592f14057a19e684/c488a/5.png 1056w"],
            "sizes": "(max-width: 1056px) 100vw, 1056px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <br />
    <br />
    <p>{`After the files have been dropped into the field, they should be entered info
a table underneath the drop zone, given the user visibility of the items they
have uploaded and the status of that process.`}</p>
    <br />
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1056px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "52.1780303030303%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABBElEQVQoz6WSzU6FMBCFeU43vpaLm/gexucwYWHAhFAEwk875Sfc5MgZvAS91I2Lj2k6p6czQ6NlWTCOI6Zp0vgf6BXRqOs69H0fwKLtNrgO6ehBr2ieZ1hr4Zw7RZyFtPmKgRcLG9DRg14/DBmPeHEwlcXlpcLza4Xs02KQe93t7F4hS/5t2FuHabB4zwUPT1c8Xq54+xDdY+5PQ21NRNlbFUbRKpdpw/tj7jCW73PaMhdxHCPLMhhjUBTFHWYlSdJgXjVrznuPaBiGVZwgTVM1PfuDbCfPc7Rtu43jJN80jT6diB+KCW8KGZZlqU8jZMjL9hlSTOq61rLPYAWcVSh/m+EXgvP6I1PDPEYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Contextual image",
            "title": "Contextual image",
            "src": "/static/9b621277bf600e7372764d3b603603b0/c488a/6.png",
            "srcSet": ["/static/9b621277bf600e7372764d3b603603b0/d6747/6.png 288w", "/static/9b621277bf600e7372764d3b603603b0/09548/6.png 576w", "/static/9b621277bf600e7372764d3b603603b0/c488a/6.png 1056w"],
            "sizes": "(max-width: 1056px) 100vw, 1056px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <br />
    <br />
    <p>{`If the user is required to input details about the files being uploaded then
the files should be displayed in cards underneath the drop zone, with the
fields to be completed on them.`}</p>
    <p>{`Upload errors can be displayed inline in this view.`}</p>
    <br />
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1056px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "82.95454545454545%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsSAAALEgHS3X78AAAB10lEQVQ4y62US47aQBCG+0Q5Ue6AZFiBJsmOK+QC2eYChNdMxGIWWWVBALGI0GAefuAX2ID/9F+kLQvZZBOkj2p3lf+u6q62Op/POB6POJ1O/+RRnPEp/vm+j8Ph8IAAnn+zj+KCIIBK01QGYRhWEmniwx6RZyMO/do4Q61gENAGCPR48MPG1+cVfv12kcRhTfxtTkr2PE/KLuN5ehu03Tk+3n/O8O7pgi/fI2SJB8f1K+JvGuqa58jx/37q5+srPlgWnj59RKfTQbvdRqvVgqXnms2mYFkGq8D4COMbjQa63S7U9u0N434fzy8vGI/HGI1G6OvnMt/+2sFggOFwKPY+ptfrYTKZQDHNNMuQ6r08Xy7I8+oNuF6vuGg/+7YuRkrOtNh+vxdc15XTSpIEcRwLHLPH6COO48jmG78hiiJBcUUGrtdrEd1ut9hsNoJt22IpwGDpS20pUHVbuLhiKRSZTqdYLBaYz+dYLpcyns1mWK1WUiKFHl0A+ooMmYHJbLfbFXCOtvySoVaQG81U7y96Gfrv56qQj4PJ0KzA/TEiBj4Xd7sUU7WwCPLkWBoPhy/x5HnHCccU4KL08+A4vq/EdEaRoRE0LxHO0fKemrYwrWQWLMP5P7UO83ac2k1IAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Contextual image",
            "title": "Contextual image",
            "src": "/static/4c898c67d291a8b97d313a2710b9eec1/c488a/7.png",
            "srcSet": ["/static/4c898c67d291a8b97d313a2710b9eec1/d6747/7.png 288w", "/static/4c898c67d291a8b97d313a2710b9eec1/09548/7.png 576w", "/static/4c898c67d291a8b97d313a2710b9eec1/c488a/7.png 1056w"],
            "sizes": "(max-width: 1056px) 100vw, 1056px",
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <br />
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      